import { useLang } from "../i18n";
import { FadeIn, MaskLine, Micro } from "./Reveal";

export default function WhyIntExt() {
  const { t } = useLang();
  const items = t("why.items");
  return (
    <section id="why" data-testid="why-section" className="scroll-mt-24 px-5 md:px-12 py-24 md:py-36 border-t border-white/5 bg-espresso/20">
      <div className="mb-12 md:mb-16">
        <FadeIn>
          <Micro className="text-gold/80">{t("why.chapter")}</Micro>
        </FadeIn>
        <h2 className="font-display uppercase leading-[0.95] text-[clamp(2rem,5vw,4rem)] mt-5">
          <MaskLine delay={0.05}>{t("why.h1a")}</MaskLine>
          <MaskLine delay={0.15}>
            {t("why.h1b")} <span className="text-gold">{t("why.h1gold")}</span>
          </MaskLine>
        </h2>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
        {items.map((w, i) => (
          <FadeIn key={w.title} delay={(i % 3) * 0.08} className="bg-ink">
            <div
              data-testid={`why-${i}`}
              className="group h-full p-7 md:p-9 hover:bg-coal transition-colors duration-500"
            >
              <div className="text-[10px] tracking-[0.3em] text-gold/80 font-semibold">
                {String(i + 1).padStart(2, "0")}
              </div>
              <h3 className="font-display uppercase text-xl md:text-2xl mt-5 group-hover:text-gold transition-colors duration-500">
                {w.title}
              </h3>
              <p className="text-sm text-cream/50 leading-relaxed mt-3">{w.desc}</p>
              <span className="block mt-6 h-px w-10 bg-gold/40 group-hover:w-full transition-all duration-700" />
            </div>
          </FadeIn>
        ))}
      </div>
    </section>
  );
}
